import { Box } from '@mui/material';
import { RichTextReadOnly as MuiTiptapReadOnly } from 'mui-tiptap';
import { EmptyStateMessage } from '@/components/common/EmptyStateMessage';
import { stripHtml } from '@/utils/stripHtml';
import { feedbackExtensions } from './richTextExtensions';

interface RichTextReadOnlyProps {
  content: string;
  variant?: 'boxed' | 'plain';
  // When provided and content is empty, renders this message instead of the
  // empty gray box (which UX flagged as looking like a bug).
  emptyMessage?: string;
}

export function RichTextReadOnly({ content, variant = 'boxed', emptyMessage }: RichTextReadOnlyProps) {
  const isEmpty = !stripHtml(content ?? '').trim();

  if (isEmpty && emptyMessage) {
    return <EmptyStateMessage message={emptyMessage} />;
  }

  return (
    <Box
      sx={{
        '& .ProseMirror': {
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
        },
        ...(variant !== 'plain' && {
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          p: 1.5,
          minHeight: 120,
          bgcolor: 'action.disabledBackground',
        }),
      }}
    >
      <MuiTiptapReadOnly key={content} content={content} extensions={feedbackExtensions} />
    </Box>
  );
}

export default RichTextReadOnly;
